module.exports = __webpack_public_path__ + "img/9.51f28cca.jpg";